var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3025 13.9939L13.2037 16.816H10.2625L11.1465 13.9939C11.3506 13.3138 11.5205 12.5147 11.6906 11.8517H11.7246C11.8945 12.5147 12.0817 13.2968 12.3025 13.9939ZM21.5336 14.6058C20.2414 14.6058 19.6974 15.779 19.6123 16.6289H23.2506C23.2678 15.864 22.9277 14.6058 21.5336 14.6058ZM28 8.00002V24C28 26.2 26.2 28 24 28H8.00002C5.8 28 4 26.2 4 24V8.00002C4 5.8 5.8 4 8.00002 4H24C26.2 4 28 5.8 28 8.00002ZM16.842 21.6446L13.1188 10.1856H10.4495L6.77714 21.6446H8.93634L9.9225 18.3973H13.5608L14.5979 21.6446H16.842ZM25.2229 17.207C25.2229 15.388 24.3387 13.1777 21.6525 13.1777C19.0003 13.1777 17.6063 15.3369 17.6063 17.632C17.6063 20.1652 19.1873 21.8145 21.8736 21.8145C23.0637 21.8145 24.0498 21.5934 24.7639 21.3043L24.4578 19.8594C23.8286 20.0972 23.1316 20.2332 22.1625 20.2332C20.8365 20.2332 19.6635 19.5873 19.6123 18.0911H25.1548C25.1889 17.9041 25.2229 17.598 25.2229 17.207Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfter);
export default __webpack_public_path__ + "static/media/after.4f5ea4fb7ec3a595d00588689a2fc605.svg";
export { ForwardRef as ReactComponent };